import React from 'react'

import {
  Button,
  CopyToClipboard,
  Modal,
  ModalInjectedProps,
} from '@sketch/components'

import { ScimPersonalAccessTokenFragment } from '@sketch/gql-types'

import {
  CopyTokenContainer,
  TokenSecret,
  TokenDetailsRow,
  PermissionsHeading,
  Callout,
} from './CopyScimPersonalAccessToken.styles'

import AccessScope from '../../components/AccessScope'
import Divider from '../../components/Divider'
import TokenDetailsItem from '../../components/TokenDetailsItem'

import { dateFormat } from '@sketch/utils'

interface CopyScimPersonalAccessTokenProps {
  token: ScimPersonalAccessTokenFragment
  secret: string
  hideModal: ModalInjectedProps['hideModal']
}

const CopyScimPersonalAccessToken: React.FC<
  CopyScimPersonalAccessTokenProps
> = props => {
  const { hideModal, token, secret } = props
  const expiresAt = token.expiresAt
    ? dateFormat(new Date(token.expiresAt))
    : 'Never'

  return (
    <>
      <Modal.Body>
        <div>
          Tokens are linked to your account. You&apos;ll only see this token
          once, so copy and store it in a safe place.
        </div>
        <CopyTokenContainer>
          <TokenSecret data-testid="token-secret">{secret}</TokenSecret>
          <CopyToClipboard title="Copy" value={secret} showIcon={false} />
        </CopyTokenContainer>
        <Divider />
        <TokenDetailsRow>
          <TokenDetailsItem title="DESCRIPTION" value={token.description} />
          <TokenDetailsItem title="EXPIRES ON" value={expiresAt} />
        </TokenDetailsRow>
        <PermissionsHeading>PERMISSIONS</PermissionsHeading>
        {token.accessScopes.map(scope => (
          <AccessScope key={scope} scope={scope} enabled={true} />
        ))}
        <Callout>
          <div>Before you go…</div>
          <div>
            Make sure you copy and store this token now — you won&apos;t be able
            to retrieve it after you close this dialog.
          </div>
        </Callout>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={hideModal}>
          Finish
        </Button>
      </Modal.Footer>
    </>
  )
}

export default CopyScimPersonalAccessToken
